export default class RedirectingPopup {
	constructor() {
		this.storageKey = 'levcharity_redirecting_country_modal';

		// Country-specific modal configuration
		this.countryConfig = {
			CA: {
				message: wp.i18n.__(
					'Looks like you are from Canada, please click here for our Canadian home page',
					'united-hatzalah'
				),
				buttonText: 'Visit Canadian Home Page',
				buttonUrl: '/en_CA/',
				excludeLang: ['en-CA'], // Don't show if already on en-CA site
			},
			/*	GB: {
				message: wp.i18n.__(
					'Looks like you are from the United Kingdom, please click here for our UK home page',
					'united-hatzalah'
				),
				buttonText: 'Visit UK Home Page',
				buttonUrl: '/en_GB/',
			},*/
		};

		this.init();
	}

	async init() {
		// Only run on homepage
		if (!document.body.classList.contains('home')) {
			return;
		}

		// Check if modal was already shown in this session
		const modalShown = sessionStorage.getItem(this.storageKey);
		if (modalShown === 'true') {
			return;
		}

		// Fetch user country code
		const userCountryCode = await this.getUserCountryCode();

		// Show modal if user is from a configured country
		if (userCountryCode && this.countryConfig[userCountryCode]) {
			// Check if current lang should exclude this country popup
			const htmlLang = document.documentElement.lang;
			const config = this.countryConfig[userCountryCode];

			if (config.excludeLang && config.excludeLang.includes(htmlLang)) {
				return;
			}

			this.createAndShowModal(userCountryCode);
		}
	}

	async getUserCountryCode() {
		// Check sessionStorage first
		let userCountryCode = sessionStorage.getItem(
			'levcharity_user_country_code'
		);

		if (!userCountryCode || userCountryCode === 'null') {
			try {
				const response = await fetch('/wp-json/maxmind/v1/geoIP');
				userCountryCode = await response.json();

				// Store in sessionStorage for future use
				if (userCountryCode && userCountryCode !== 'local') {
					sessionStorage.setItem(
						'levcharity_user_country_code',
						userCountryCode
					);
				}
			} catch (error) {
				console.error('Error fetching country code:', error);
				return null;
			}
		}

		return userCountryCode;
	}

	createAndShowModal(countryCode) {
		const config = this.countryConfig[countryCode];

		// Get logo from localized WordPress data
		const logo = window.countryLogos?.canada || '';

		// Create modal HTML with country-specific content
		const modalHTML = `
            <div class="redirecting-country-modal">
                <div class="modal-overlay"></div>
                <div class="modal-content">
                    <div class="header_image">${logo}</div>
                    <p class="modal-message levcharity_heading lg-size bold text__heading">${config.message}</p>
                    <a class="levcharity_button large primary_button" href="${config.buttonUrl}">${config.buttonText}</a>
                </div>
            </div>
        `;

		// Insert modal into DOM
		document.body.insertAdjacentHTML('beforeend', modalHTML);

		// Get the modal element
		this.modal = document.querySelector('.redirecting-country-modal');

		// Mark as shown in sessionStorage
		sessionStorage.setItem(this.storageKey, 'true');

		// Add click event to close modal when clicking overlay
		const overlay = this.modal.querySelector('.modal-overlay');
		if (overlay) {
			overlay.addEventListener('click', () => {
				this.modal.style.display = 'none';
			});
		}
	}
}
